import { render, staticRenderFns } from "./UpliftStat.vue?vue&type=template&id=0732142a&scoped=true&"
import script from "./UpliftStat.vue?vue&type=script&lang=js&"
export * from "./UpliftStat.vue?vue&type=script&lang=js&"
import style0 from "./UpliftStat.vue?vue&type=style&index=0&id=0732142a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0732142a",
  null
  
)

export default component.exports